import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import FitnessCoachLanding from "../../components/fitness-coach-leads/fitness-coach-landing";

const FitnessCoachLeads = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return <FitnessCoachLanding userInfoData={userInfoData} />;
};

export default FitnessCoachLeads;
